import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Button } from '../components/ui/Button'
import { ErrorBox } from '../components/ui/Card'

const pageClass = 'min-h-screen bg-bg flex items-center justify-center p-8'
const cardClass = 'bg-surface rounded-xl shadow-card p-10 w-full max-w-[440px] text-center'

// Needs a click to confirm: email link scanners open links automatically and must not unsubscribe anyone.
export default function Unsubscribe() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') ?? ''
  const [done, setDone] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  const handleClick = async () => {
    setSubmitting(true)
    setError(null)
    try {
      const res = await fetch('/api/auth/unsubscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      })
      if (!res.ok) {
        const err = (await res.json()) as { detail?: string }
        throw new Error(err.detail ?? 'Could not unsubscribe.')
      }
      setDone(true)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not unsubscribe.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className={pageClass}>
      <div className={cardClass}>
        <h1 className="m-0 mb-3 text-[1.5rem] font-bold text-text-heading">Reminder emails</h1>
        {done ? (
          <p className="text-text-2 m-0">You won't receive vaccination or appointment reminders any more. Contact your vet practice to turn them back on.</p>
        ) : (
          <>
            <p className="text-text-2 mb-6">Stop receiving vaccination and appointment reminder emails?</p>
            {error && <ErrorBox className="mb-4">{error}</ErrorBox>}
            <Button onClick={() => void handleClick()} disabled={submitting || !token}>
              {submitting ? 'Unsubscribing…' : 'Unsubscribe'}
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
